import { Navigate } from "react-router";

export default function CustomFieldsPage() {
  return <Navigate to="/settings/clients?tab=fields" replace />;
}
